<template>
  <div class="p-grid">
		<div class="p-col-12">
			<div class="card p-shadow-1">
				<h5>Novo Funcionário</h5>
                <hr>
				<Panel header="Dados do Funcionário">
					<div class="p-grid">
						<div class="p-col-fixed" style="width:150px;">
							<div style="width: 130px; height: 128px;" class="p-mb-2">
								<img :src="fotoPerfil" alt="Foto Perfil" ref="imgFotoPerfil" style="width: 100%; height: 100%; object-fit: cover;" />
							</div>
							<Button icon="pi pi-upload" class="p-button-rounded p-button-primary p-mr-2" title="Selecionar foto..." @click="uploadImagem"/>
							<Button icon="pi pi-video" class="p-button-rounded p-button-primary p-mr-2" title="Foto da WebCam" @click="exibirFormWebCam"/>							
							<Button icon="pi pi-trash" class="p-button-rounded p-button-danger" title="Excluir" @click="limparFotoPerfil"/>
						</div>
						<div class="p-col">	
							<div class="p-fluid p-formgrid p-grid">
								<div class="p-field p-col-12 p-md-6">
									<label for="nome">Nome</label>
									<InputText id="nome" v-model="funcionario.nome" required="true" autocomplete="off" maxlength="50"/>
									<small class="p-invalid" v-if="enviandoForm && !funcionario.nome">Informe o nome</small>
								</div>
								<div class="p-field p-col-12 p-md-6">
									<label for="nomeCurto">Nome reduzido</label>
									<InputText id="nomeCurto" v-model.trim="funcionario.nomeCurto" autocomplete="off" maxlength="12"/>
								</div>
								<div class="p-field p-col-12 p-md-3">
									<label for="dataNascimento">Data de nascimento</label>
									<Calendar id="dataNascimento" v-model="funcionario.dataNascimento" :showIcon="true" :manualInput="false" dateFormat="dd/mm/yy" 
									:monthNavigator="true" :yearNavigator="true" :yearRange="rangeData" :locale="localeCalendarBR"/>								
								</div>
								<div class="p-field p-col-12 p-md-3">
									<label for="pis">PIS</label>
									<InputText id="pis" v-model.trim="funcionario.pis"
									placeholder="____._____.__-_" required="true"
									autocomplete="off" maxlength="15" @keyup="formatarPis"/>
									<small class="p-invalid" v-if="enviandoForm && !funcionario.pis">Informe o pis</small>
								</div>
								<div class="p-field p-col-12 p-md-3">
									<label>CPF</label>
									<InputMask v-model.trim="funcionario.cpf" mask="999.999.999-99" placeholder="___.___.___-__" autocomplete="off" 
									required="true" maxlength="14"/>
									<small class="p-invalid" v-if="enviandoForm && !funcionario.cpf">Informe o cpf</small>
								</div>
								<div class="p-field p-col-12 p-md-3">
									<label>E-mail</label>
									<InputText v-model="funcionario.email" autocomplete="off" maxlength="50"/>							
								</div>							
							</div>
						</div>
					</div>
				</Panel>
				<Panel header="Relação com a Empresa" class="p-mt-3 p-mb-3">
					<div class="p-fluid p-formgrid p-grid">
						<div class="p-field p-col-12 p-md-12">
							<label for="empresa">Empresa</label>
							<Dropdown id="empresa" v-model.number="idCnpjSelecionado" :options="cnpjs" optionLabel="cnpjNome" optionValue="id" placeholder="Selecione"
								required="true" @change="listarCentrosCustos"/>
							<small class="p-invalid" v-if="enviandoForm && !idCnpjSelecionado">Selecione uma empresa</small>
						</div> 							
					</div>
					<div class="p-fluid p-formgrid p-grid">						
						<div class="p-field p-col-12 p-md-4">
							<label for="cracha">Crachá</label>
							<InputText id="cracha" v-model="funcionario.cracha" maxlength="14"/>	
							<small class="p-invalid" v-if="enviandoForm && !funcionario.cracha">Informe o craché</small>						
						</div>
						<div class="p-field p-col-12 p-md-4">
							<label for="registro">Registro</label>
							<InputText id="registro" v-model.trim="funcionario.registro" required="true" autocomplete="off" maxlength="20"/>
							<small class="p-invalid" v-if="enviandoForm && !funcionario.registro">Informe o registro</small>
						</div>
						<div class="p-field p-col-12 p-md-4">
							<label for="dataAdmissao">Data de admissão</label>
							<Calendar id="dataAdmissao" v-model="funcionario.dataAdmissao" :showIcon="true" :manualInput="false" dateFormat="dd/mm/yy"
							:monthNavigator="true" :yearNavigator="true" :yearRange="rangeData" :locale="localeCalendarBR"/>								
						</div>
					</div>
					<div class="p-fluid p-formgrid p-grid">						
						<div class="p-field p-col-12 p-md-6">
							<label for="cargo">Cargo</label>
							<Dropdown id="cargo" v-model.number="idCargoSelecionado" :filter="true" :options="cargos" optionLabel="nome" optionValue="id" 
								required="true" placeholder="Selecione"/>		
							<small class="p-invalid" v-if="enviandoForm && !idCargoSelecionado">Selecione um cargo</small>						
						</div>
						<div class="p-field p-col-12 p-md-6">
							<label for="centroCusto">Centro de custo</label>
							<Dropdown id="centroCusto" v-model.number="idCentroCustoSelecionado" :filter="true" :options="centrosCustos" optionLabel="nome" optionValue="id" 
								required="true" placeholder="Selecione"/>	
							<small class="p-invalid" v-if="enviandoForm && !idCentroCustoSelecionado">Selecione um centro de custo</small>
						</div>					
					</div>
					<div class="p-fluid p-formgrid p-grid">						
						<div class="p-field p-col-12 p-md-6">
							<label for="contrato">Escala de horários</label>
							<div class="p-inputgroup">								
								<InputText id="contrato" v-model="contrato.descricao" readonly/>
								<Button title="Buscar escalas de horários" icon="pi pi-search" @click="listarContratos"/>
							</div>	
							<small class="p-invalid" v-if="enviandoForm && !contrato.id">Selecione a escala de horários</small>														
						</div>
						<div class="p-field p-col-12 p-md-2">
							<label>Senha para ponto via teclado</label>
							<Password :feedback="false" v-model.trim="funcionario.senhaTecladoSemBio" autocomplete="off" maxlength="4" @keyup="validarValor"/>	
						</div>		
						<div class="p-field p-col-12 p-md-4">
							<label for="contrato">Data para ativação</label>
							<div class="p-inputgroup">		
								<span class="p-inputgroup-addon">
									<Checkbox v-model="funcionario.agendarAtivacao" :binary="true" />
								</span>
								<InputText v-model="funcionario.dataAtivacao" readonly 
									:disabled="!funcionario.agendarAtivacao" @click="selecionarExibirDataAtivacao"/>
							</div>														
						</div>									
					</div>
					<div class="p-fluid p-formgrid p-grid">	
						<div class="p-field p-col-12 p-md-4">
							<label>Dupla verificação</label>
							<div class="p-field-checkbox">							
								<Checkbox v-model="funcionario.duplaVerificacao" :binary="true"/>							
							</div>
						</div>
					</div>	
				</Panel>
				<Button label="Fechar" class="p-button-secondary" icon="pi pi-times" @click="cancelar"/>
				<Button label="Salvar" class="p-ml-2" icon="pi pi-check" @click="salvar"/>		
			</div>
		</div>
		<Dialog :visible.sync="exibirDialogEscalaHorarios" header="Escala de Horários" :modal="true" class="p-fluid" :style="{width: '500px'}">			
			<div class="p-fluid p-formgrid p-grid">					
				<div class="p-field p-col-12 p-md-12">
					<label>Escala de horários</label>							
					<Dropdown v-model="idContratoSelecionado" :filter="true" :options="contratos" 
					optionLabel="descricao" optionValue="refId" dataKey="refId" appendTo="body"/>								
				</div>
				<!-- <div class="p-field p-col-12 p-md-12">
					<label for="dataInicioContrato">Data de início</label>
					<Calendar id="dataInicioContrato" v-model="dataInicioContrato" :showIcon="true" :manualInput="false" 
						:monthNavigator="true" :yearNavigator="true" :yearRange="rangeData"  dateFormat="dd/mm/yy" appendTo="body" :locale="localeCalendarBR"/>	
				</div> -->
			</div>
			<template #footer>
				<Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="fecharModal"/>
				<Button label="Selecionar" icon="pi pi-check" @click="selecionarContrato" />
			</template>
		</Dialog>

		<Dialog :visible.sync="exibirDialogWebCamFoto" header="WebCam" :modal="true" @hide="desligarWebCam">			
			<WebCam ref="cam" :controlarBotaoSalvar="controlarBotaoSalvar"/>
			<template #footer>
				<Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="desligarWebCam"/>
				<Button label="Salvar" icon="pi pi-check" @click="capturarImagem" />
			</template>
		</Dialog>

		<Dialog :visible.sync="exibirDialogDataAtivacao" header="Data para Ativação" :modal="true" :style="{width: '400px'}">			
			<div class="p-fluid p-formgrid p-grid">	
				<div class="p-field p-col-12 p-md-12">	
					<p>Selecione uma data para ativação do funcionário.</p>
					<p id="pLimitesDataAtivacao">Limites: {{ limitesDataAtivacao() }}</p>				
					<Calendar v-model="dataAtivacao" :showIcon="true" :manualInput="false" dateFormat="dd/mm/yy" appendTo="body" :locale="localeCalendarBR"/>	
				</div>				
			</div>
			<template #footer>				
				<Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="exibirDialogDataAtivacao=false"></Button>
				<Button label="OK" icon="pi pi-check" @click="selecionarDataAtivacao"></Button>			
			</template>
		</Dialog>

		<form id="formUploadImagem"><input type="file" id="inputFileImagemFoto" style="opacity: 0" v-show="false"></form>

  </div>
</template>

<script>

import RedimensionaImagem from '@/plugins/redimensionaImagem/RedimensionaImagem.js';
import WebCam from '@/components/util/WebCam.vue';
import FuncionarioService from '@/service/FuncionarioService';
import CargoService from '@/service/CargoService';
import FuncionarioPesquisaService from '@/service/FuncionarioPesquisaService';
import CentroCustoService from '@/service/CentroCustoService';
import Funcionario from '@/model/Funcionario';
import { exibirMensagem, exibirMensagemSis, localeCalendarBR, FOTO_PERFIL_PADRAO } from '@/global';
import { mapGetters } from 'vuex';

export default {
	redimensionaImagem: null,
	cargoService: null,
	centroCustoService: null,
	funcionarioService: null,
	funcionarioPesquisaService: null,
	data() {
		return {
			base64FotoPerfil: '',
			fotoPerfil: FOTO_PERFIL_PADRAO,						
			rangeData: '',
			funcionario: new Funcionario(),
			dataAtivacao: new Date(),
			exibirDialogDataAtivacao: false,
			exibirDialogWebCamFoto: false,
			exibirDialogEscalaHorarios: false,
			enviandoForm: false,
			idCnpjSelecionado: null,
			cnpjs: [],
			idCargoSelecionado: null,
			cargos: [],
			idCentroCustoSelecionado: null,
			centrosCustos: [],
			idContratoSelecionado: null,
			contratos: [],
			contrato: {descricao: null, id: null},	
			bloquerSalvarImagem: true,	
			localeCalendarBR: localeCalendarBR	
		}
	},
	methods: {
		...mapGetters('sessao', ['getDadosRequisicao', 'getCacheEmpresa']),		
		salvar() {
			this.enviandoForm = true;
			if(!this.funcionario.nome || !this.funcionario.pis || !this.funcionario.cpf
				|| !this.funcionario.cracha	|| !this.funcionario.registro || !this.idCnpjSelecionado
				|| !this.idCargoSelecionado || !this.contrato || !this.idCentroCustoSelecionado) {
				return;
			}
			let cnpj = null;
			for(let i = 0; i < this.cnpjs.length; i++) {
				if(this.idCnpjSelecionado == this.cnpjs[i].id) {
					cnpj = {...this.cnpjs[i]};				
					break;
				}
			}
			let cargo = null;
			for(let i = 0; i < this.cargos.length; i++) {
				if(this.idCargoSelecionado == this.cargos[i].id) {
					cargo = {...this.cargos[i]};				
					break;
				}
			}
			let centroCusto = null;
			for(let i = 0; i < this.centrosCustos.length; i++) {
				if(this.idCentroCustoSelecionado == this.centrosCustos[i].id) {
					centroCusto = {...this.centrosCustos[i]};				
					break;
				}
			}
			let funcionario = {...this.funcionario};
			funcionario.pis = this.funcionario.pis.replace(/\D/gim, '');
			funcionario.cpf = this.funcionario.cpf.replace(/\D/gim, '');
			funcionario.dataNascimento = this.formatarData(funcionario.dataNascimento);
			funcionario.dataCadastro = this.formatarData(funcionario.dataCadastro);
			funcionario.dataFinal = this.formatarData(funcionario.dataFinal);
			funcionario.dataAdmissao = this.formatarData(funcionario.dataAdmissao);
			funcionario.dataDemissao = this.formatarData(funcionario.dataDemissao);
			if(!funcionario.agendarAtivacao) {
				funcionario.dataAtivacao = this.formatarData(new Date());
			} else {
				funcionario.dataAtivacao = this.formatarData(funcionario.dataAtivacao);
			}			
			let requisicao = {
				funcionario: funcionario,
				dataInicioContrato: this.formatarData(new Date()),
				cnpj: cnpj,
				cargo: cargo,
				centroCusto: centroCusto,
				contrato: {...this.contrato},
				imagemPerfilBase64: this.base64FotoPerfil,
				usuarioRequisicao: {...this.getDadosRequisicao()},
			};
            this.funcionarioService.salvar(requisicao)
			.then(resp => {        
				this.funcionario = new Funcionario();
				this.idCnpjSelecionado = null;
				this.idCargoSelecionado = null;
				this.idCentroCustoSelecionado = null;
				this.contrato = {descricao: null, id: null};
				this.enviandoForm = false;   
				this.formatarDataAtivacao(); 
				this.limparFotoPerfil();				
				exibirMensagem(this, resp);  
			})
			.catch(erro => {
				console.log(erro)
				this.enviandoForm = false;
				exibirMensagem(this, erro)
			});
		},
		selecionarContrato() {			
			for(let i = 0; i < this.contratos.length; i++) {
				if(this.idContratoSelecionado == this.contratos[i].refId) {
					this.contrato = this.contratos[i];
					this.fecharModal();
					break;
				}
			}
		},
		selecionarDataAtivacao() {	
			let umDia = 86400000;
			let hoje = new Date((new Date().getTime() + umDia));			 		
			let limite = new Date((new Date().getTime() + (umDia * 6)));
			hoje.setHours(0,0,0,0);
			limite.setHours(0,0,0,0);			
			this.dataAtivacao.setHours(0,0,0,0);		
			if(this.dataAtivacao.getTime() < hoje.getTime() || this.dataAtivacao.getTime() > limite.getTime()) {
				if(document.getElementById('pLimitesDataAtivacao')) {
					document.getElementById('pLimitesDataAtivacao').classList.add('ik-text-danger');
				}
				return;
			}				
			let dt = this.dataAtivacao;
			let mes = dt.getMonth();
			let dia = dt.getDate();
			this.funcionario.dataAtivacao = (dia < 10 ? '0' + dia : '' + dia) + '/' + ((mes + 1) < 10 ? '0'+(mes+1) : ''+(mes+1)) + '/' + dt.getFullYear();			
			this.exibirDialogDataAtivacao = false;
		},
		limitesDataAtivacao() {
			let umDia = 86400000;
			let hoje = new Date((new Date().getTime() + umDia));			 		
			let setDias = new Date((new Date().getTime() + (umDia * 6)));
			let mes = hoje.getMonth();
			let dia = hoje.getDate();
			let dataDe = (dia < 10 ? '0' + dia : '' + dia) + '/' + ((mes + 1) < 10 ? '0'+(mes+1) : ''+(mes+1)) + '/' + hoje.getFullYear();		
			mes = setDias.getMonth();
			dia = setDias.getDate();
			let dataAte = (dia < 10 ? '0' + dia : '' + dia) + '/' + ((mes + 1) < 10 ? '0'+(mes+1) : ''+(mes+1)) + '/' + setDias.getFullYear();
			return dataDe + ' - ' + dataAte;
		},
		/**
		 * Formata a data de ativação.
		 */
		formatarDataAtivacao() {
			let amanha = new Date();
			amanha.setDate(amanha.getDate() + 1);				
			this.dataAtivacao = amanha;
			let dt = this.dataAtivacao;
			let mes = dt.getMonth();
			let dia = dt.getDate();
			this.funcionario.dataAtivacao = (dia < 10 ? '0' + dia : '' + dia) + '/' + ((mes + 1) < 10 ? '0'+(mes+1) : ''+(mes+1)) + '/' + dt.getFullYear();	
		},
		/**
		 * 
		 */
		formatarPis() {
			let arrPis = this.funcionario.pis.replace(/\D/gim, '').split('');			
			let total = arrPis.length;
			let novoPis = '';
			for(let i = 0; i < total; i++) {
				novoPis += arrPis[i];
				// 123. || 1234.
				if((i == 2 && total <= 11) 
					|| (i == 3 && total == 12)) {
					novoPis += '.';									
				}
				// 45678. || 56789.
				if((i == 7 && total <= 11) 
					|| (i == 8 && total == 12)) {
					novoPis += '.';						
				}
				// 00-
				if((i == 9 && total <= 11) 
					|| (i == 10 && total == 12)) {
					novoPis += '-';						
				}	
				this.funcionario.pis = novoPis;				
			}
		},
		/**
		 * Exibe modal para selecionar data de ativação.
		 */
		selecionarExibirDataAtivacao() {
			if(this.funcionario.agendarAtivacao) {
				this.exibirDialogDataAtivacao = true;
			}
		},
		fecharModal() {
			this.exibirDialogEscalaHorarios = false;			
		},
		validarValor(event) {		
			let valor = this.funcionario.senhaTecladoSemBio.replace(/[^\d]+/g, '');
			this.funcionario.senhaTecladoSemBio = valor; 
			event.target.value = valor;
		},
		listarContratos() {
			let usuarioRequisicao = {...this.getDadosRequisicao()};         
            this.funcionarioPesquisaService.listarContratos(usuarioRequisicao)
				.then(resp => {                   
					this.contratos = resp.data;		
					this.contratos.forEach((contrato, i) => {
                        contrato['refId'] = i + '_' + contrato.id;
                    });	
					this.idContratoSelecionado = this.contratos[0].refId;		
					this.exibirDialogEscalaHorarios = true;
                })
                .catch(erro => {exibirMensagem(this, erro)});
		},
		listarCnpjs() {
            // Cache dados
            let cacheEmpresa = this.getCacheEmpresa();
            this.cnpjs = cacheEmpresa.cnpjs;
            this.centrosCustos = cacheEmpresa.centrosCustos;       
            if(cacheEmpresa.idCnpjSelecionado) {
                this.idCnpjSelecionado = cacheEmpresa.idCnpjSelecionado;
            }
		},
		listarCentrosCustos() {
            let requisicao = {
                idCnpj: this.idCnpjSelecionado,
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };
            this.centroCustoService.listarCentrosCustosUsuario(requisicao)
			.then(resp => {    
				this.centrosCustos = resp.data;                
			})
			.catch(erro => {exibirMensagem(this, erro)});
        },
		listarCargos() {
            let usuarioRequisicao = {...this.getDadosRequisicao()};         
            this.cargoService.listar(usuarioRequisicao)
				.then(resp => {                   
					this.cargos = resp.data;					
                })
                .catch(erro => {exibirMensagem(this, erro)});
		},
		limparFotoPerfil() {
			this.base64FotoPerfil = '';
			this.$refs.imgFotoPerfil.src = FOTO_PERFIL_PADRAO;
		},
		controlarBotaoSalvar(bloquear) {
			this.bloquerSalvarImagem = bloquear;
		},
		exibirFormWebCam() {
			this.exibirDialogWebCamFoto = true;			
		},
		capturarImagem() {		
			this.$refs.cam.capturarImagemBase64()
				.then((imagem) => {
					this.base64FotoPerfil = imagem.base64.replace('data:image/jpeg;base64,', '');
					this.$refs.imgFotoPerfil.src = imagem.blobURL;
					this.desligarWebCam();
				});			
		},		
		desligarWebCam() {			
			this.exibirDialogWebCamFoto = false;
		},	
		uploadImagem() {
			setTimeout(() => {							
				document.querySelector('#inputFileImagemFoto').click();
				document.querySelector('#inputFileImagemFoto')
					.addEventListener('change', () => {
						let imagem = document.querySelector('#inputFileImagemFoto').files[0];						
						let partesItem = document.querySelector('#inputFileImagemFoto').value.split('\\');   
						let exts = ['jpg', 'jpeg'];
						let nome = partesItem[partesItem.length-1];
						let ext = nome.split('.')[1];  
						if(!exts.includes(ext.toLowerCase())) {
							exibirMensagemSis(this, 'Selecione uma imagem do tipo JPG ou JPEG', true);
							return;
						}
						let url = URL.createObjectURL(imagem);
						let imgTeste = new Image;						
						imgTeste.onload = () => {		
							if(imgTeste.width > 1920 || imgTeste.height > 1080) {
								URL.revokeObjectURL(imgTeste.src);
								exibirMensagemSis(this, 'Tamanho máximo: L 1920 x A 1080', true);
								return;
							}
							// Se a imagem for válida, atualiza a URL e converte para Base64
							this.$refs.imgFotoPerfil.src = url;
							let reader = new FileReader();
							reader.onloadend = () => {
								this.base64FotoPerfil = reader.result
									.replace('data:image/jpeg;base64,', '')
									.replace('data:image/jpg;base64,', '');
							}
							reader.readAsDataURL(imagem);
						}						
						imgTeste.src = url;						
					});
			}, 400);
		},
		formatarData(data) {
			if(!data) {
				return null;
			}
			let strData = null;
			if(data instanceof Date) {
				let dt = data;
				let mes = dt.getMonth();
				let dia = dt.getDate();
				strData = dt.getFullYear() + '-' + ((mes + 1) < 10 ? '0'+(mes+1) : ''+(mes+1)) + '-' + (dia < 10 ? '0' + dia : '' + dia);
			} else {
				let partes = data.split('/');
				strData = partes[2] + '-' + partes[1] + '-' + partes[0];
			}
			return strData;
		},		
		cancelar() {
            this.$router.push('/cadastros/funcionarios');
        },
		criarRangeData() {
			let hoje = new Date();
			let anoAtual = hoje.getFullYear();   
			if(hoje.getMonth() == 11) {
				anoAtual++;
			}
			this.rangeData = (anoAtual-90)+':'+anoAtual;    
		},
	},
	created() {
		this.redimensionaImagem = new RedimensionaImagem();
		this.cargoService = new CargoService();
		this.funcionarioService = new FuncionarioService();		
		this.funcionarioPesquisaService = new FuncionarioPesquisaService();	
		this.centroCustoService = new CentroCustoService();
		this.formatarDataAtivacao();	
	},
	mounted() {        
		this.listarCnpjs();	
		this.listarCargos();	
		this.criarRangeData();		
		this.formatarDataAtivacao();	
	},
	components: {
		WebCam,
	}
}
</script>

<style>

</style>